/** Matches workspace onboarding “Data retention” presets (`workspaces.settings.retention_days`). */
export const WORKSPACE_RETENTION_PRESETS = [
  { days: 30, title: '30 Days', subtitle: 'Minimalist & highly private' },
  { days: 90, title: '90 Days', subtitle: 'Standard workspace balance', recommended: true },
  { days: 180, title: '180 Days', subtitle: 'Extended historical context' },
  { days: 360, title: '360 Days', subtitle: 'Near-annual archive' },
] as const;

export type WorkspaceRetentionPreset = (typeof WORKSPACE_RETENTION_PRESETS)[number];

function parseRetentionDays(raw: unknown): number | null {
  if (raw == null) return null;
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
  if (typeof raw === 'string') {
    const n = parseInt(raw, 10);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

/** Human-readable line for UI (timeline, tooltips, etc.). */
export function describeWorkspaceDataRetention(settings?: Record<string, unknown> | null): string {
  const days = parseRetentionDays(settings?.retention_days);
  if (days == null) {
    return 'Not configured in workspace settings';
  }
  const preset = WORKSPACE_RETENTION_PRESETS.find((p) => p.days === days);
  if (preset) {
    return `${preset.title} - ${preset.subtitle}`;
  }
  return `Custom: ${days} days`;
}
